import { render } from "./Benefits.vue?vue&type=template&id=54b46a4e&ts=true"
import script from "./Benefits.vue?vue&type=script&lang=ts"
export * from "./Benefits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__